/* eslint-disable no-undef */
export const HandleEvent = (event) => {
  let evento = '';
  switch(true){
  case /^\/$/.test(event):
    evento = 'FRONT_PAGE';
    break;
  case /^\/login(\/[^/]+)?$/.test(event):
    evento = 'LOGIN_PAGE';
    break;
  case /^\/live_searches$/.test(event):
    evento = 'LIST_LIVE_SEARCHS';
    break;
  case /^\/reported_articles$/.test(event):
    evento = 'LIST_REPORTED_ARTICLES';
    break;
  case /^\/profile$/.test(event):
    evento = 'VIEW_PROFILE';
    break;
  case /^\/client_accounts\/client_black_sellers$/.test(event):
    evento = 'VIEW_LIST_BLACK_SELLERS';
    break;
  case /^\/client_accounts\/client_white_sellers$/.test(event):
    evento = 'VIEW_LIST_WHITE_SELLERS';
    break;
  case /^\/reports\/noticed_articles$/.test(event):
    evento = 'LIST_HISTORY_NOTICED';
    break;
  case /^\/reports\/custom_reports$/.test(event):
    evento = 'LIST_REPORTS_NOTICED';
    break;
  case /^\/video_instructions$/.test(event):
    evento = 'VIEW_HELP_VIDEOS';
    break;
  case /^\/support_form$/.test(event):
    evento = 'VIEW_SUPPORT_FORM';
    break;
  case /^\/live_searches\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(event):
    evento = 'LIST_ITEMS_SEARCH';
    break;
  case /^\/article_catalogo_detail\/[0-9A-Z]{11}$/.test(event):
    evento = 'VIEW_ARTICLE_CATALOG';
    break;
  case /^\/article_detail\/[0-9A-Z]{13}$/.test(event):
    evento = 'VIEW_ARTICLE_ITEM';
    break;
  case /^\/reports\/noticed_articles\/[0-9]{8}$/.test(event):
    evento = 'VIEW_NOTICED_ARTICLE';
    break;      
  case /^\/help_support\/[AZ0-9]{20}$/.test(event):
    evento = 'VIEW_HELP_SUPPORT';
    break;    
  default:
    evento = event;
  }
    
  return evento;
};

export const getDeviceType = (userAgent) => {
  if (/mobile|android|iphone|ipad|ipod/.test(userAgent)) {
    return 'Mobile';
  } else if (/tablet/.test(userAgent)) {
    return 'Tablet';
  } else {
    return 'Desktop';
  }
};

export const trackEvent = (location, detail) => {
  const session_id = localStorage.getItem('session_id');

  const event = HandleEvent(location.pathname);


  const track = {
    session_id,
    version: process.env.REACT_APP_VERSION,
    event, 
    page: `${location.pathname}${location.search || ''}`,
    search: location.search || '',
    from: document.referrer.replace(window.location.protocol + '//','').replace(window.location.host,''),
    date: new Date().getTime(),
    agent: navigator.userAgent.toLowerCase(),
    device: getDeviceType(navigator.userAgent),
    type: 'nav',
    detail: Object.keys(detail).length === 0 ? '' : JSON.stringify(detail)
  };

  if(event === 'LIST_ITEMS_SEARCH' && Object.keys(detail).length === 0) {
    const id = location.pathname.split('/').pop();
    track.detail = {
      type: 'VIEW_SEARCH',
      id
    };
  }
    
  return track;
};

export const MANUAL_EVENT = {
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
  CHANGE_PROFILE: 'CHANGE_PROFILE',
  CREATE_REPORT: 'CREATE_REPORT',
  FILTER_REPORT: 'FILTER_REPORT',
  DELETE_REPORT: 'DELETE_REPORT',
  SEND_REPORT: 'SEND_REPORT',
  DOWNLOAD_REPORT: 'DOWNLOAD_REPORT',
  SEARCH_BY: 'SEARCH_BY',
  FILTER_SEARCH: 'FILTER SEARCH',
  FILTER_SUSPICIOUS_REPORT: 'FILTER_SUSPICIOUS_REPORT',
  REPORT_ARTICLE: 'REPORT_ARTICLE',
  MASIVE_UPLOAD: 'MASSIVE UPLOAD',
  REPORT_ARTICLE_EDIT: 'REPORT_ARTICLE_EDIT',
  APPROVED_ARTICLE: 'APPROVED_ARTICLE',
  CLICK_ON: {
    ADHERIR_DERECHOS: 'Click a Adherir derechos',
    DOWNLOAD_REPORT: 'Click descarga reporte',
    SELECCION_MULTIPLE: 'Click en Selección multiple'
  },
  REACTIVATE_PUBLICACION: 'Reactivación de publicación',
  SELLERS_ACTION: {
    MARK_SUSPICIOUS_SELLER: 'MARK SUSPICIOUS SELLER ',
    UNMARK_SUSPICIOUS_SELLER: 'UNMARK SUSPICIOUS SELLER',
    MARK_TRUSTED_SELLER:'MARK TRUSTED SELLER',
    UNMARK_TRUSTED_SELLER: 'UNMARK TRUSTED SELLER',
    CREATE_LIVE_SEARCH: 'CREATE SELLER LIVE SEARCH'
  }
};
